import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import { useOrder } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { usePath } from '@/hooks/usePath';
import { useTab } from '@/hooks/useTab';
import { CloseIcon } from '@/icons';
import TabsBlock, { type TabChild } from '@/components/TabsBlock';
import OverviewTab from '../OverviewTab';
import type { OrderOverlayTab } from '../types';
import { classes, getDefaultTab } from './utils';

export type TabsColumnProps = {
  isFetchingData: boolean;
};

export default function TabsColumn({ isFetchingData }: TabsColumnProps) {
  const { activeOrderId, onClearActiveOrder } = useAppState();
  const { searchParams, pushParams } = usePath();
  const order = useOrder(activeOrderId);
  const [defaultTab, setDefaultTab] = useTab<OrderOverlayTab>(
    getDefaultTab(searchParams)
  );

  useEffect(() => {
    const tab = searchParams.get('orderOverlayTab');
    if (tab !== null && tab !== defaultTab) {
      handleSelectTab(tab as OrderOverlayTab);
    }
  }, [searchParams]);

  const handleSelectTab = (tab: OrderOverlayTab) => {
    setDefaultTab(tab);
    pushParams({ orderOverlayTab: tab });
  };

  if (!order) return null;

  let tabs: TabChild[] = [
    <OverviewTab
      key="overview"
      isFetchingData={isFetchingData}
      name="overview"
      label="Overview"
    />,
  ];

  return (
    <div className={classes.wrapper}>
      <div className={classes.buttonsWrapper}>
        <IconButton aria-label="close" onClick={onClearActiveOrder}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </div>
      <TabsBlock<OrderOverlayTab[]>
        className={classes.tabsBlock}
        name="order-info"
        bodyClassName={classes.tabBody}
        defaultTab={defaultTab}
        onChange={handleSelectTab}>
        {tabs}
      </TabsBlock>
    </div>
  );
}
